import { AfterViewInit, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LoggingService } from '../../shared/services/logging';
import { HasValidTokens } from '../store';
import { QuickbooksService } from '../quickbooks.services';
import * as fromSettings from '../../company-setting';
import * as fromLoading from '../../shared/loading';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'ef-access-granted',
    templateUrl: './access-granted.component.html',
    styleUrls: ['./access-granted.component.scss'],
    standalone: false
})
export class AccessGrantedComponent implements AfterViewInit {
    @Input() code: string;
    @Input() state: string;
    @Input() realmId: string;
    public message: any;
    public companyMismatchWarning$: Observable<boolean>;
    constructor(
        private service: QuickbooksService,
        private loadingService: fromLoading.LoadingService,
        private store: Store,
        private log: LoggingService,
        private ss: StateService
    ) {
        this.message = 'Connecting...';
        this.log.verbose({ type: 'AccessGrantedComponent::' });
        loadingService.Load();
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: 'QuickbooksOnline'
            })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: 'CompanyName'
            })
        );
    }
    ngAfterViewInit(): void {
        this.service
            .Connect(this.code, this.state, this.realmId)
            .then(resp => {
                this.log.verbose({
                    type: 'AccessGrantedComponent:Connect',
                    resp
                });
                this.store.dispatch(new HasValidTokens(true));
                this.message =
                    resp?.error?.Message ?? resp?.Message ?? 'Connected.';
                setTimeout(() => {
                    this.ss.go('main');
                }, 5000);
            })
            .catch(err => {
                this.log.verbose({
                    type: 'AccessGrantedComponent:Connect:catch',
                    err
                });
                this.loadingService.Stop();
                this.store.dispatch(new HasValidTokens(false));
                if (err && err.status === 401) {
                    this.message = 'Unauthorized.';
                }
                this.message =
                    err?.error?.Message ??
                    err?.message ??
                    err ??
                    'Unknown Error.';
            })
            .finally(() => {
                this.log.verbose({
                    type: 'AccessGrantedComponent:Connect:finally'
                });
                this.loadingService.Stop();
            });
    }
}
